"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '-1 0 12 13';

var Calendar = function Calendar() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M8.6514156,1.5 L10.5,1.5 L10.5,4.581 L0,4.581 L0,1.5 L1.96779882,1.5 L1.96779882,2.149 C1.96779882,2.7445 2.45378781,3.2275 3.05391825,3.2275 C3.65303411,3.2275 4.13953039,2.7445 4.13953039,2.149 L4.13953039,1.5 L6.47968403,1.5 L6.47968403,2.149 C6.47968403,2.7445 6.96567301,3.2275 7.56529616,3.2275 C8.16542661,3.2275 8.6514156,2.7445 8.6514156,2.149 L8.6514156,1.5 Z"
  }), _react["default"].createElement("polygon", {
    points: "0 8.25 3 8.25 3 5.5 0 5.5"
  }), _react["default"].createElement("polygon", {
    points: "3.75 8.25 6.75 8.25 6.75 5.5 3.75 5.5"
  }), _react["default"].createElement("polygon", {
    points: "7.5 8.25 10.5 8.25 10.5 5.5 7.5 5.5"
  }), _react["default"].createElement("polygon", {
    points: "0 11.75 3 11.75 3 9 0 9"
  }), _react["default"].createElement("polygon", {
    points: "3.75 11.75 6.75 11.75 6.75 9 3.75 9"
  }), _react["default"].createElement("polygon", {
    points: "7.5 11.75 10.5 11.75 10.5 9 7.5 9"
  }), _react["default"].createElement("path", {
    d: "M3.0575,2.552 C2.7495,2.552 2.5,2.3025 2.5,1.9945 L2.5,0.5575 C2.5,0.25 2.7495,0 3.0575,0 C3.3655,0 3.615,0.25 3.615,0.5575 L3.615,1.9945 C3.615,2.3025 3.3655,2.552 3.0575,2.552"
  }), _react["default"].createElement("path", {
    d: "M7.5575,2.552 C7.2495,2.552 7,2.3025 7,1.9945 L7,0.5575 C7,0.25 7.2495,0 7.5575,0 C7.8655,0 8.115,0.25 8.115,0.5575 L8.115,1.9945 C8.115,2.3025 7.8655,2.552 7.5575,2.552"
  }));
};

var _default = (0, _createSvgIcon["default"])(Calendar, {
  viewBox: viewBox
});

exports["default"] = _default;